var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"1200px","margin":"0 auto","margin-top":"50px"}},[_c('mainView',{tag:"component",attrs:{"items":_vm.items,"state":_vm.state},on:{"setSave":_vm.setSave}},[_c('bottomMenu',{attrs:{"slot":"bottomMenu","items":_vm.items,"state":_vm.state},on:{"callback":_vm.setState},slot:"bottomMenu"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }